import React from "react";
import {NavLink, NavLinkProps} from "react-router-dom";
import Icon from "../../../../../icons/icon/icon";
import {ICON_SIZE} from "../../../../../icons/icon-props-interface";
import IconNext from "../../../../../icons/icon-next/icon-next";
import FontBody1 from "../../../../../fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../fonts/font-props";
import pageUrlCoordinationStore from "../../../page-url-broadcaster/page-url-coordination-store";
// import ActivateCoverageBadge from "../activate-coverage-badge/activate-coverage-badge";

/** this file holds all the custom menu links for the sidebar.
 * The links' rendering is controlled by the MenuItemContents component.
*/
export type MenuItemProps = {
    label: string;
    children: React.ReactNode;
}
export type MenuLinkProps = MenuItemProps & Pick<NavLinkProps, 'to'|'onClick'>;

export const isActiveClassName = (to: string, strict: boolean = false): string => {
    const laravelPath = pageUrlCoordinationStore.constructLaravelAbsoluteUrl(document.location.pathname);
    const normalizedTarget = to.replace(/\/+$/, '');
    const normalizedPath = laravelPath.replace(/\/+$/, '');

    if (normalizedPath === normalizedTarget || (!strict && normalizedPath.startsWith(`${normalizedTarget}/`))) {
        return 'active';
    }
    return '';
};

export const BackAsAdminMenuLink: React.FC<MenuLinkProps> = ({ to, label, onClick, children }) => {
    return (
        <NavLink to={to} className="side-menu-item back-as-admin stick-to-bottom" onClick={onClick}>
            <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>{label}</FontBody1>
            {children}
            <Icon color={'var(--color-primary-2)'} size={ICON_SIZE.MEDIUM} Component={IconNext} />
        </NavLink>
    );
}

export const MainMenuItemLink: React.FC<MenuLinkProps> = ({  to, label, onClick, children  }) => {
    return (
        <a href={to.toString()} className={`side-menu-item main-menu-item-link ${isActiveClassName(to.toString(), true)}`} onClick={onClick}>
            {children}
            <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>{label}</FontBody1>
        </a>
    );
}

export const CoverageMenuItemLink: React.FC<MenuLinkProps> = ({  to, label, onClick, children  }) => {
    return (
        <a href={to.toString()} className={`side-menu-item ${isActiveClassName(to.toString())}`} onClick={onClick}>
            <FontBody1 color={FONT_COLOR.PRIMARY2}>{label}</FontBody1>
            {children}
            {/* 29/09/2025: we hide coverage badge for now, until product will decide on its functionality */}
            {/* <ActivateCoverageBadge /> */}
        </a>
    );
}

export const DefaultMenuItemLink: React.FC<MenuLinkProps> = ({  to, label, onClick, children  }) => {
    return (
        <a href={to.toString()} className={`side-menu-item ${isActiveClassName(to.toString())}`} onClick={onClick}>
            <FontBody1 color={FONT_COLOR.PRIMARY2}>{label}</FontBody1>
            {children}
        </a>
    )
}

export const TopLevelCollapsibleMenuItem: React.FC<MenuItemProps> = ({ label, children }) => {
    return (
        <div className="side-menu-item">
            {children}
            <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{label}</FontBody1>
        </div>
    );
}

export const DefaultMenuItem: React.FC<MenuItemProps> = ({ label, children }) => {
    return (
        <div className="side-menu-item">
            {children}
            <FontBody1 color={FONT_COLOR.PRIMARY2}>{label}</FontBody1>
        </div>
    );
}